import { connect } from "react-redux";
import EmployeeTicketList from "./approvalEmTicket";
import { bindActionCreators } from "redux";
import { fetchEmTicket , postUpdateEMStatus, getEmployeeFilterDropDown} from "services/redux/maintenance/employeeTickets/action";
const mapStateToProps = (state) => ({
  employeeTicket: state.employeeTicketReducer.employeeTicket,
  employeeFilterList: state.employeeTicketReducer.employeeFilterList
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchEmTicket,
      postUpdateEMStatus,
      getEmployeeFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTicketList);
